<!-- One choice out of a few, as a row of segments (RTL: the first option on the right) - the small sibling
     of the customer page's tab row: a gray track, the chosen segment white with purple text.
     v-model = the chosen option's id; options = [{ id, name, icon }]. -->
<template>
    <div class="segmentedChoice" role="radiogroup">
        <button v-for="option in options"
                :key="option.id"
                type="button"
                role="radio"
                class="segmentedChoiceOption"
                :class="{ segmentedChoiceOn: option.id == value }"
                :aria-checked="option.id == value ? 'true' : 'false'"
                @click="$emit('input', option.id)">
            <i v-if="option.icon" :class="option.icon"></i>
            <span>{{ option.name }}</span>
        </button>
    </div>
</template>

<script>
export default {
    name: 'SegmentedChoice',

    props: {
        value: { default: null },
        options: { type: Array, default: () => [] },
    },
};
</script>

<style>
.segmentedChoice {
    display: flex;
    flex-wrap: wrap;
    gap: 3px;
    padding: 3px;
    border: 1px solid #e6e8ef;
    border-radius: 8px;
    background: #f4f5f9;
}

.segmentedChoiceOption {
    flex: 1 1 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    min-height: 32px;
    padding: 5px 10px;
    border: 0;
    border-radius: 6px;
    background: transparent;
    color: #4f546d;
    font-size: 14px;
    white-space: nowrap;
    cursor: pointer;
    transition: background-color .15s ease, color .15s ease;
}

.segmentedChoiceOption:hover {
    background: rgba(255, 255, 255, .65);
    color: #7650c4;
}

.segmentedChoiceOption.segmentedChoiceOn {
    background: #fff;
    color: #7650c4;
    font-weight: 600;
    box-shadow: 0 1px 4px rgba(42, 49, 66, .16);
}
</style>
